import { takeLatest, put, call } from 'redux-saga/effects';
import { Map } from 'immutable';
import * as adminApi from '../../service/api/admin';
import * as devicesActions from '../device/action';
import * as adminActions from './action';
import { getTranslation } from 'src/i18n/translations';
import toast from 'src/utils/toast';



export function * adminRoot () {
  yield takeLatest(adminActions.FETCH_CLIENTS, fetchClients);
  yield takeLatest(adminActions.FETCH_TIERS, fetchTiers);
  yield takeLatest(adminActions.UPDATE_CLIENT, updateClient);
  yield takeLatest(adminActions.CREATE_FACILITY, createFacility);
  yield takeLatest(adminActions.FETCH_CLIENTS_FOR_MANAGER, fetchClientsForManager);
}

function * updateClient (action) {
  try {
    const client = yield call(adminApi.updateClient, action);
    yield put(adminActions.updateClientSuccess(client));
  } catch (err: any) {
    yield put(adminActions.updateClientFailed(Map(err)));
  }
}
function * fetchClientsForManager (action) {
  try {
    const clients = yield call(adminApi.fetchClientsForManager, action);
    console.log(clients.toJS());
    yield put(adminActions.fetchClientsForManagerSuccess(clients));
  } catch (err: any) {
    yield put(adminActions.fetchClientsForManagerFailed(Map(err)));
  }
}
function * fetchClients (action) {
  try {
    const clients = yield call(adminApi.fetchClients, action);
    yield put(adminActions.fetchClientsSuccess(clients));
  } catch (err: any) {
    yield put(adminActions.fetchClientsFailed(Map(err)));
  }
}

function * createFacility (action) {
  try {
    const client = yield call(adminApi.createFacility, action);
    yield put(adminActions.createFacilitySuccess(client));
    // Refresh clients list to include the new facility
    yield put(adminActions.fetchClientsForManager());
    yield put(devicesActions.setSettingsModalClose(null));
  } catch (err: any) {
    if (err.status === 400) {
      toast.error(getTranslation(err?.response?.data?.message)
       || getTranslation('toast.failedToCreateFacility'));
    }
    else {
      toast.error(getTranslation('toast.failedToCreateFacility'));
    }
    yield put(adminActions.createFacilityFailed(Map(err)));
  }
}

function * fetchTiers (action) {
  try {
    const tiers = yield call(adminApi.fetchTiers, action);
    yield put(adminActions.fetchTiersSuccess(tiers));
  } catch (err: any) {
    yield put(adminActions.fetchTiersFailed(Map(err)));
  }
}
